export enum ProtectedEntityTypes {
  COMPANY = 0x0002,
  COMPANIES_COLLECTION = 0x0003,
  COMPANY_NETWORK = 0x0004,
  COMPANY_FOLDER = 0x0005,
  EPS_CUSTOM_GROUPS = 258,
  TYPE_EPS_CUSTOM_GROUP = 261,
  TYPE_EPS_CUSTOM_COMPUTER = 262,
  TYPE_EPS_AD_COMPUTER = 260,
  TYPE_EPS_AWS_INSTANCE = 265,
  TYPE_CONTAINER = 804,
  SVE_CUSTOM_GROUPS = 592,
  TYPE_SVE_CUSTOM_GROUP = 593,

  TYPE_VMWARE_COLLECTION = 900,
}

export const Companies = {
  TYPE_COMPANY: 0x0002,
  TYPE_COMPANIES_COLLECTION: 0x0003,
  TYPE_COMPANY_NETWORK: 0x0004,
  TYPE_COMPANY_FOLDER: 0x0005,

  Type: {
    PARTNER: 0x00,
    CUSTOMER: 0x01,
  },

  viewType: {
    COMPANIES_VIEW: 10,
  },
};

export const ProtectedEntitiesSVE = {
  ROOT: 0x0200,
  VMWARE_COLLECTION: 0x0210,
  VMWARE_CENTER: 0x0211,
  VMWARE_DATACENTER: 0x0222,
  VMWARE_FOLDER: 0x0223,
  VMWARE_COMPUTE_RESOURCE: 0x0224,
  VMWARE_CLUSTER_COMPUTE_RESOURCE: 0x0225,
  VMWARE_RESOURCE_POOL: 0x0226,
  VMWARE_VIRTUAL_APP: 0x0227,
  VMWARE_DATASTORE: 0x0228,
  VMWARE_HOST_SYSTEM: 0x0229,
  VMWARE_VIRTUAL_MACHINE: 0x0230,
  VMWARE_STORAGE_POD: 0x0231,
  XEN_COLLECTION: 0x0240,
  XEN_SERVER: 0x0241,
  XEN_FOLDER: 0x0242,
  XEN_POOL: 0x0243,
  XEN_HOST: 0x0244,
  XEN_VIRTUAL_MACHINE: 0x0245,
  CUSTOM_GROUPS: 0x0250,
  TYPE_EXCLUDED_FOLDER: 0x0260,
  CUSTOM_GROUP: 0x0251,
  VIRTUAL_MACHINE: 0x0252,

  // nutanix
  NUTANIX_COLLECTION: 0x0270,
  NUTANIX_SERVER: 0x0271,
  NUTANIX_CLUSTER: 0x0272,
  NUTANIX_HOST: 0x0273,
  NUTANIX_VIRTUAL_MACHINE: 0x0274,

  // AWS
  AMAZON_EC2_COLLECTION: 0x0290,
  AMAZON_EC2_SERVER: 0x0291,
  AMAZON_EC2_REGION: 0x0292,
  AMAZON_EC2_AZ: 0x0293,
  AMAZON_EC2_INSTANCE: 0x0294,

  // AZURE
  AZURE_COLLECTION: 0x0300,
  AZURE_SERVER: 0x0301,
  AZURE_REGION: 0x0302,
  AZURE_AVAILABILITY_ZONE: 0x0303,
  AZURE_VIRTUAL_MACHINE: 0x0304,

  viewType: {
    SVE: 8,
    SVE_ROOT: 8,
    SVE_CUSTOM_GROUPS: 11,

    vmware: {
      HOSTS_AND_CLUSTERS: 1,
      VIRTUAL_MACHINES: 2,
      DEPLOY_SVA_CONTAINER_VIEW: 9,
    },

    xen: {
      SERVER: 3,
      FOLDER: 4,
    },

    SVE_NUTANIX: 12,
    SVE_AMAZON_EC2: 14,
    SVE_AZURE: 15,
    SVE_CONTAINERS: 16,
  },
};

export const ProtectedEntitiesEPS = {
  ROOT: 0x0100,
  ACTIVE_DIRECTORY: 0x0101,
  CUSTOM_GROUPS: 0x0102,
  TYPE_AD_COMPUTER_GROUP: 0x0103,
  TYPE_AD_COMPUTER: 0x0104,
  TYPE_CUSTOM_GROUP: 0x0105,
  TYPE_EXCLUDED_FOLDER: 0x0110,
  TYPE_COMPUTER: 0x0106,
  TYPE_AWS_GROUP: 0x0107,
  TYPE_AWS_REGION: 0x0108,
  TYPE_AWS_INSTANCE: 0x0109,
  TYPE_AWS_AZ: 0x0111,
  TERMINATED_INSTANCES_GROUP: 0x0112,
  TYPE_AWS_ACCOUNT: 0x0113,

  TYPE_VMWARE_COLLECTION: 900,
  TYPE_VMWARE_CENTER: 901,
  TYPE_VMWARE_DATACENTER: 903,
  TYPE_VMWARE_FOLDER: 904,
  TYPE_VMWARE_COMPUTE_RESOURCE: 905,
  TYPE_VMWARE_CLUSTER_COMPUTE_RESOURCE: 906,
  TYPE_VMWARE_RESOURCE_POOL: 907,
  TYPE_VMWARE_VIRTUAL_APP: 908,
  TYPE_VMWARE_HOST_SYSTEM: 909,
  TYPE_VMWARE_VIRTUAL_MACHINE: 910,

  viewType: {
    EPS_TREE_VIEW: 0x07,
  },

  FILTERS: {
    TAGS: {
      AWS_EC2: 0x01,
    },
    DEPTH: {
      SHOW_ALL_ITEMS_RECURSIVELY: 0x01,
      SHOW_ITEMS_WITHIN_THE_SELECTED_FOLDERS: 0x02,
    },
  },
};

export const ProtectedEntitiesMDM = {
  ROOT: 0x0400,
  ACTIVE_DIRECTORY: 0x0401,
  CUSTOM_GROUPS: 0x0402,
  TYPE_EXCLUDED_FOLDER: 0x0410,
  TYPE_AD_USER_GROUP: 0x0403,
  TYPE_AD_USER: 0x0404,
  TYPE_CUSTOM_GROUP: 0x0405,
  TYPE_CUSTOM_USER: 0x0406,
  TYPE_DEVICE: 0x0407,
};

export const ProtectedEntitiesContainers = {
  TYPE_COLLECTION: 800,
  TYPE_CUSTOM_GROUPS: 801,
  TYPE_FOLDER: 802,
  TYPE_HOST: 803,
  TYPE_CONTAINER: 804,
};
